import React from 'react';
import { Modal, Space, Typography } from 'antd';
import FormButton from '../common/formbutton';

interface PageVersionEditModalProps {
    isModalOpen: boolean;
    handleCancel: () => void;
    handlePropertiesClick: () => void;
    handleContentClick: () => void;
    draftForPublished: string | null;
    handleGotoDraft: () => void;
}

const PageVersionEditModal: React.FC<PageVersionEditModalProps> = ({
    isModalOpen,
    handleCancel,
    handlePropertiesClick,
    handleContentClick,
    draftForPublished,
    handleGotoDraft
}) => {
    return (
        <Modal
            title="Edit Page Version"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
        >
            <Space
                size="middle"
                direction="vertical"
                style={{ marginTop: '16px' }}
            >
                <Typography.Text>
                    Choose what you want to edit:
                </Typography.Text>

                <FormButton
                    title="Properties"
                    tooltip="Allows you to change properties of pageversion (e.g. name), without need to publish."
                    onClick={handlePropertiesClick}
                />

                {draftForPublished === null ? (
                    <FormButton
                        title="Content"
                        tooltip="Changing content creates a new draft of the pageversion (copy of the finalized) which would need to be published again."
                        onClick={handleContentClick}
                    />
                ) : (
                    <FormButton
                        title="Content (Draft)"
                        tooltip="Draft already created, click to edit content."
                        onClick={handleGotoDraft}
                    />
                )}
            </Space>
        </Modal>
    );
};

export default PageVersionEditModal;